import { EventTypeId } from '../types/eventType';

export const configuredLandingPageEventTypeIds = [EventTypeId.SOCCER];
